const en = {
  'map-box-url': 'mapbox://styles/egotkacheco/cl84bc22f009214qgjhseae7y',
  'sign-in': 'Log in',
  'login-placeholder': 'Login',
  'login-required': 'Please enter your email address',
  'password-placeholder': 'Password',
  'password-required': 'Please enter your password',
  next: 'Next',
  'forgot-password-q': 'Forgot password?',
  'error-user-not-found': 'User not found',
  'forgot-password': 'Forgot password',
  'forgot-password-successfully-sended': 'Check your email inbox',
  'restore-password': 'Restore password',

  'navigation-map': 'Map',
  'navigation-analytic': 'Analytics',
  'navigation-users': 'Users',

  search: 'Search',
  add: 'Add',
  edit: 'Edit',
  remove: 'Delete',
  cancel: 'Cancel',
  save: 'Save',
  status: 'Status',
  name: 'Name',
  surname: 'Surname',
  patronymic: 'Middle name',
  role: 'Role',
  email: 'Email address',
  invited: 'Invited',
  accepted: 'Accepted',
  user: 'user',
  admin: 'Administrator',
  regioncoordinator: 'Regional manager',
  coordinator: 'Assignment manager',

  timetable: 'Timetable',
  table: 'Table',
  exceptions: 'Exception management',
  analytic: 'Analytics',
  'evaluations-completed': 'Evaluations completed',
  plan: 'Plan',
  completed: 'Completed',
  'appointment-quotas': 'Appointed quotas taking into account fulfillment',
  assigned: 'Assigned',
  'rcv-applics': 'Rcv Applics',
  'yesterday-percent': 'How did it work in % yesterday',
  'yesterday-completed': 'Completed yesterday',
  'plan-fulffillment': 'Fulfillment of the plan by day',
  assistance: 'Assistants',
  'completed-surveys': 'Completed surveys',
  managers: 'Managers',
  'not-available': 'Not available',
  fact: 'Fact',
  prediction: 'Prediction',
  export: 'Export',
  regions: 'Regions',
  projects: 'Projects',
  'region/project/city': 'Region/Project/City',
  'project/region/city': 'Project/Region/City',
  'shopper-assigned': 'Assigned',
  total: 'Total',
  'not-assigned': 'Not assigned',
  project: 'Project',
  'visits-limit': 'Limit of visits',
  rotation: 'Rotation',
  'start/end-project': 'Start date/Due date',
  start: 'Start date',
  end: 'Due date',
  'forbidden-days': 'Forbidden days',
  step: 'Step',
  comment: 'Comment',
  limit: 'Limit',
  'not-selected': 'Not selected',
  'month-1': '1 month',
  'month-2': '2 months',
  'month-3': '3 months',
  'month-4': '4 months',
  'month-5': '5 months',
  'month-6': '6 months',

  'map-search': 'Search on the map',
  'address-search': 'Address search',
  address: 'Address',
  locations: 'Locations',
  shoppers: 'Shoppers',
  my: 'My',
  all: 'All',
  reset: 'Reset',
  apply: 'Apply',
  back: 'Back',
  'visits-total': 'Visits total:',
  age: 'Age',
  sex: 'Sex',
  male: 'Male',
  female: 'Female',
  experiance: 'Work experience',
  'visits-number': 'Number of visits',
  'region/country': 'Region/Country',
  'car-available': 'Availability of a car',
  'shopper-out': 'On-site shopper',
  'auto-model': 'Auto model',
  'shoppers-total': 'Total shoppers:',

  'empty-basket': 'Add stores to the list',
  'select-shopper': 'Choose a shopper',
  find: 'Find',

  Выполнено: 'Completed',
  'В процессе': 'Assigned',
  Заявка: 'Application',
  'Не назначено': 'Rcv applics',
  Отклонено: 'Canceled',

  rate: 'Pay rate',
  'shopper-login': 'Shopper’s login',
  'visit-scenario': 'Scenario of the visit',
  'visit-summary': 'Survey summary',
  info: 'Information',
  history: 'History',
  'visit-calendar': 'Calendar of visits',
  more: 'More',
  'visit-created': 'Created',
  'visit-location': '№ of the location ',

  'month.': 'mos',
  'show-more': 'Show more',

  'shopper-visits_min': 'Visits',
  'shopper-visits': 'Visits (submitted surveys)',
  'shopper-registration_min': 'Registration',
  'shopper-registration': 'Registration (date)',
  'shopper-last-login': 'Log in (last login date)',
  login: 'Login',

  'shopper-auto': 'Car',
  'shopper-job': 'Place of employment',
  'shopper-assigned-visits': 'Assigned surveys',

  'assign-visit': 'Assign visit',

  'select-visits': 'Select visits',
  'shopper-fact-address': 'Shopper’s address',
  'with-rotation': 'In view of rotation',
  'with-step': 'In view of step',
  'search-radius': 'Search radius',
  km: 'km',

  'select-shoppers': 'Select shoppers',
  'visit-assign': 'Assign visit ',
  'visit-date': 'Date of the visit',
  finish: 'Finish',

  '1-mos': '1 month',
  '1-3-mos': '1-3 months',
  '3-6-mos': '3-6 months',
  '6-mos': '6 months  - 1 year',
  'more-1-year': 'More than 1 year',

  'less-10': 'Up to 10',
  'more-500': 'More than 500',
}
export default en
